{
  "SET_NEW_PASSWORD": {
    "TITLE": "Set new password",
    "PASSWORD": {
      "LABEL": "Mật khẩu",
      "PLACEHOLDER": "Mật khẩu",
      "ERROR": "Mật khẩu quá ngắn."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Confirm password",
      "PLACEHOLDER": "Xác nhận mật khẩu",
      "ERROR": "Mật khẩu không khớp."
    },
    "API": {
      "SUCCESS_MESSAGE": "Đổi mật khẩu thành công.",
      "ERROR_MESSAGE": "Could not connect to chat server. Please try again."
    },
    "CAPTCHA": {
      "ERROR": "Đã hết hạn xác minh. Vui lòng giải mã captcha một lần nữa."
    },
    "SUBMIT": "Gửi"
  }
}
